var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2C79F7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#settings_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.8,
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M12.93 10a1.1 1.1 0 0 0 .22 1.213l.04.04a1.333 1.333 0 1 1-1.886 1.886l-.04-.04a1.1 1.1 0 0 0-1.213-.22 1.1 1.1 0 0 0-.667 1.007v.113a1.333 1.333 0 1 1-2.667 0v-.06a1.1 1.1 0 0 0-.72-1.006 1.1 1.1 0 0 0-1.213.22l-.04.04a1.333 1.333 0 0 1-2.176-1.454c.067-.162.165-.31.29-.433l.04-.04a1.1 1.1 0 0 0 .22-1.213 1.1 1.1 0 0 0-1.007-.667h-.114a1.333 1.333 0 0 1 0-2.667h.06A1.1 1.1 0 0 0 3.064 6a1.1 1.1 0 0 0-.22-1.213l-.04-.04a1.333 1.333 0 1 1 1.887-1.887l.04.04a1.1 1.1 0 0 0 1.213.22h.053a1.1 1.1 0 0 0 .667-1.006v-.114a1.333 1.333 0 0 1 2.667 0v.06a1.1 1.1 0 0 0 .666 1.007 1.1 1.1 0 0 0 1.214-.22l.04-.04a1.334 1.334 0 1 1 1.886 1.887l-.04.04a1.1 1.1 0 0 0-.22 1.213v.053a1.1 1.1 0 0 0 1.007.667h.113a1.333 1.333 0 1 1 0 2.667h-.06a1.1 1.1 0 0 0-1.006.666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settings_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export { SvgSettings as ReactComponent };
export default __webpack_public_path__ + "ba690d19377c76cb33a84c983e1994be.svg";